import HorizontalScroll from "@Components/HorizontalScroll";
import ListWithUsCard from "./components/ListWithUsCard";
import styles from "./ListWithUs.module.scss";
import config from "@Config/index";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import { SCREEN_SIZE, useResponsiveness } from "hooks/useResponsiveness";
//

const ListWithUs = ({ isDesktop = false }) => {
  const { t } = useTranslationHook();
  const { isAbove } = useResponsiveness();
  const isAboveSM = isAbove(SCREEN_SIZE.SM);
  const partnerWithUs = t("home.listandpartnerwithus.partnerwithus");
  const listWithUs = t("home.listandpartnerwithus.listwithus");
  const listProperties = t("home.listandpartnerwithus.listproperties");
  const partnerWithUsChinaDesc = t("home.listandpartnerwithus.partnerwithuschinadesc");
  const listWithUsChinaDesc = t("home.listandpartnerwithus.listwithuschinadesc");

  return (
    <>
      <div
        className={formatClassNames(styles.listWithUsSection, isDesktop && styles.lwsDesktopOuter)}
      >
        {isDesktop && isAboveSM ? (
          <div className={styles.lwsDesktopContainer} data-testid="partner-with-us-banner">
            <ListWithUsCard
              title={partnerWithUs}
              actualCta="Partner With Us"
              subtitle={
                config.IS_CHINA_APP ? (
                  partnerWithUsChinaDesc
                ) : (
                  <>
                    {t("home.listandpartnerwithus.partnerwithusdefaultdesc1")} <br />
                    {t("home.listandpartnerwithus.partnerwithusdefaultdesc2")}
                  </>
                )
              }
              ctaText={partnerWithUs}
              href="/partner"
              isDesktop
              imgUrl={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/Partner Card (Web).png?q=90`}
            />
            <ListWithUsCard
              title={listWithUs}
              actualCta="List With Us"
              subtitle={
                config.IS_CHINA_APP ? (
                  listWithUsChinaDesc
                ) : (
                  <>
                    {t("home.listandpartnerwithus.listwithusdefaultdesc1")} <br />
                    {t("home.listandpartnerwithus.listwithusdefaultdesc2")}
                  </>
                )
              }
              ctaText={listProperties}
              href="/list"
              isDesktop
              imgUrl={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/List Card (Web).png?q=90`}
            />
          </div>
        ) : (
          <>
            <HorizontalScroll className={styles.horizontalScroll}>
              <ListWithUsCard
                title={partnerWithUs}
                subtitle={
                  config.IS_CHINA_APP ? (
                    partnerWithUsChinaDesc
                  ) : (
                    <>
                      {t("home.listandpartnerwithus.partnerwithusdefaultdesc1")} <br />
                      {t("home.listandpartnerwithus.partnerwithusdefaultdesc2")}
                    </>
                  )
                }
                ctaText={partnerWithUs}
                href="/partner"
                imgUrl={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/Partner with us.png`}
              />
              <ListWithUsCard
                title={listWithUs}
                subtitle={
                  config.IS_CHINA_APP ? (
                    listWithUsChinaDesc
                  ) : (
                    <>
                      {t("home.listandpartnerwithus.listwithusdefaultdesc1")} <br />
                      {t("home.listandpartnerwithus.listwithusdefaultdesc2")}
                    </>
                  )
                }
                ctaText={listProperties}
                href="/list"
                imgUrl={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/List with us.png`}
              />
            </HorizontalScroll>
          </>
        )}
      </div>
      <div
        className={formatClassNames(styles.bottomBorder, isDesktop && styles.bottomBorderDesktop)}
      />
    </>
  );
};

export default wrapperHOC(ListWithUs, {
  componentName: "ListWithUs-Home",
  showForChina: true,
  showForMiniProgram: false,
  showForApp: false,
});
